<ziro-loading-block [hidden]="!isLoading || modalProperties()"></ziro-loading-block>
@if (!isLoading) {
  <div data-automation="ziro-voicemail-wrapper">
    <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
      <ziro-voicemail-form
        (voicemailDeleted)="onDeleteComplete($event)"
        (voicemailSaved)="onSaveComplete($event)"
        (voicemailRefUpdated)="onVoicemailRefUpdated($event)"
        [fieldConfig]="voicemailFieldConfig"
        [endUser]="endUser"
        [isExistingVoicemail]="isExistingVoicemail"
        [isExistingVoicemailOnPublicPhone]="isExistingVoicemailOnPublicPhone"
        [unityServerId]="unityServerId"
        [entity]="originalValue"
        [isPending]="isPending"
        [serverId]="serverId"
        [siteId]="siteId()"
        [extension]="modalProperties() ? modalProperties()?.button?.dn?.extension : extension"
        [voicemail]="voicemail"
        [originalValue]="originalValue"
        [username]="username"
        [alternateExtensions]="alternateExtensions"
        [modalProperties]="modalProperties()"
        [global360View]="global360View"
      ></ziro-voicemail-form>
    </ziro-collapsible-section-card>
  </div>
}
